import { render, staticRenderFns } from "./myLogin.vue?vue&type=template&id=7245bc89&"
import script from "./myLogin.vue?vue&type=script&lang=js&"
export * from "./myLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports